import { JSX } from 'react'

import { IconProps } from '../../icon'

const Dislike: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M39.1506 25.178C38.3074 26.3618 36.9777 27.0266 35.5345 27.0266H32.4372C32.2751 27.0266 32.1616 27.1239 32.1129 27.1726C32.0643 27.2374 31.9994 27.3347 32.0318 27.4644C32.3399 29.313 32.1291 31.1454 31.4156 32.7832C30.2805 35.4102 28.1887 36.8048 26.6482 37.5182C25.7563 37.9236 24.7347 37.8588 23.9077 37.3399C23.0969 36.821 22.5942 35.9291 22.5942 34.9561V30.6752C22.5942 28.6644 20.9564 27.0266 18.9457 27.0266H12.4594C9.99455 27.0266 8 25.0321 8 22.5673V14.4593C8 11.9945 9.99455 10 12.4594 10H32.8264C34.7561 10 36.4426 11.2324 37.0588 13.0486L39.7668 21.1565C40.2208 22.5348 40.01 23.9943 39.1506 25.178ZM10.4324 14.4593V22.5673C10.4324 23.6862 11.3405 24.5942 12.4594 24.5942H16.1079V12.4324H12.4594C11.3405 12.4324 10.4324 13.3405 10.4324 14.4593ZM37.4479 21.9186L34.7399 13.8107C34.4642 12.9837 33.6859 12.4324 32.8102 12.4324H18.5403V24.5942H18.9457C22.3024 24.5942 25.0266 27.3185 25.0266 30.6752V34.9561C25.0266 35.1345 25.1239 35.248 25.205 35.2967C25.2698 35.3453 25.432 35.4102 25.6104 35.3129C26.7779 34.7778 28.3346 33.7237 29.1779 31.8103C29.713 30.5941 29.8589 29.2644 29.6157 27.8698C29.486 27.059 29.6968 26.232 30.2319 25.5996C30.767 24.951 31.5616 24.5942 32.4048 24.5942H35.502C36.1669 24.5942 36.7669 24.2861 37.1398 23.751C37.529 23.2159 37.6263 22.551 37.4155 21.9186H37.4479Z'
      fill='black'
    />
  </svg>
)

export default Dislike
